import Const from 'constants';

const defaultState = {
    data: {
        userPointsType: 'adminPoints',
    },
    getUserPointsType() {
        return this.data.userPointsType;
    },
    isUserPointsTypeEqual(type) {
        return this.getUserPointsType() === type;
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.SET_USER_POINTS_TYPE) {
        state = {...state};
        state.data.userPointsType = action.value;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: {
                userPointsType: 'adminPoints',
            },
        };
    }

    return state;
}
